import { useContext } from 'react';
import { AuthContext } from '../components/general/TSAuthProvider';
import JwtUtils from '../router/JwtUtils';

export const useAuth = () => {
  const { token } = useContext(AuthContext);
  return { isAuthenticated: !!token && token !== 'undefined' && token !== 'null' && Object.keys(token).length > 0 && !JwtUtils.isExpired() };
};